const routes = [
  {
    path: '',
    component: () => import('@/views/eden/exit/Wrapper.vue'),
    children: [
      {
        path: '/eden/exit',
        name: 'edenExit',
        component: () => import('@/views/eden/exit/Main.vue'),
      },
      {
        path: '/eden/exit/:id',
        name: 'edenExitDetails',
        component: () => import('@/views/eden/exit/Details.vue'),
      },
    ],
  },
]

export default routes
